import { createApp, h } from 'vue'
import { Spin } from 'ant-design-vue'

export default function register(app) {
  app.directive('loading', {
    updated(el, binding) {
      if (!binding.value) {
        const dom = el.querySelector('.xn-loading')
        if (dom) dom.style.display = 'none'
      }
    },
    unmounted(el, binding) {
      if (!binding.value) {
        const dom = el.querySelector('.xn-loading')
        if (dom) dom.parentNode.removeChild(dom)
      }
    },
    beforeMount(el, binding) {
      if (binding.value) {
        const spin = createApp({
          render() {
            const views: any = []
            const icon = h(Spin, {
              size: ['large', 'small', 'default'].includes(binding.arg) ? binding.arg : 'large',
              style: {
                position: 'absolute',
                top: '35%',
                'z-index': 99991,
              }
            })

            // const text = h('div', {
            //     style: {
            //       position: 'absolute',
            //       top: '35%',
            //       width: '100%',
            //       color: '#1677ff',
            //       'margin-left': '1em',
            //       'margin-top': '30px',
            //       'text-align': 'center',
            //       'font-size': '12px',
            //       'z-index': 99991,
            //       'text-shadow': '0 1px 2px #ffffff',
            //     }
            //   },
            //   'Loading...'
            // )
            views.push(icon)
            return h('div', { class: 'xn-loading' }, views)
          }
        }).mount('#spin')
        el.appendChild(spin.$el)
      }
    }
  })
}
